module.exports = __webpack_public_path__ + "static/media/rightmn.eea33db8.png";